import React, { useState } from "react";
import Modal from "../../../../components/ui/Modal";
import Button from "../../../../components/ui/Button";
import { Search, Plus, Check } from "lucide-react";

// Mock Admin Inventory
const adminInventory = [
  { id: "inv_1", name: "Official T-Shirt", type: "Merchandise", basePrice: 300, image: "https://placehold.co/100x100?text=T-Shirt" },
  { id: "inv_2", name: "Signed Poster", type: "Merchandise", basePrice: 150, image: "https://placehold.co/100x100?text=Poster" },
  { id: "inv_3", name: "Digital Album", type: "Digital", basePrice: 200, image: "https://placehold.co/100x100?text=Album" },
  { id: "inv_4", name: "Sticker Pack", type: "Merchandise", basePrice: 50, image: "https://placehold.co/100x100?text=Stickers" },
];

const CreateProductModal = ({ isOpen, onClose, onSave }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [markup, setMarkup] = useState(0);

  const filteredInventory = adminInventory.filter(item => 
    item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleAdd = () => {
    if (!selectedProduct) return;
    onSave({
      id: `prod_${Date.now()}`,
      name: selectedProduct.name,
      priceETB: selectedProduct.basePrice + Number(markup),
      sales: 0,
      imageUrl: selectedProduct.image,
      type: selectedProduct.type
    });
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Add Product from Inventory">
      <div className="space-y-6">
        <div className="relative">
          <Search className="absolute left-3 top-3 text-slate-400" size={18} />
          <input
            type="text"
            placeholder="Search admin inventory..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-10 pr-4 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
          />
        </div>

        <div className="max-h-60 overflow-y-auto space-y-2">
          {filteredInventory.map(item => (
            <div 
              key={item.id}
              onClick={() => setSelectedProduct(item)}
              className={`flex items-center p-3 rounded-lg border cursor-pointer transition-colors ${
                selectedProduct?.id === item.id 
                  ? "border-primary bg-primary/5" 
                  : "border-slate-200 hover:bg-slate-50"
              }`}
            >
              <img src={item.image} alt={item.name} className="w-12 h-12 rounded bg-slate-200 object-cover" />
              <div className="ml-3 flex-1">
                <p className="font-medium text-slate-800">{item.name}</p>
                <p className="text-xs text-slate-500">{item.type} • Base Price: {item.basePrice} ETB</p>
              </div>
              {selectedProduct?.id === item.id && <Check className="text-primary" size={20} />}
            </div>
          ))}
        </div>

        {selectedProduct && (
          <div className="p-4 bg-slate-50 rounded-lg border border-slate-200">
            <label className="block text-sm font-medium text-slate-700 mb-2">Add Markup (Your Profit)</label>
            <div className="flex items-center space-x-2">
              <input
                type="number"
                value={markup}
                onChange={(e) => setMarkup(e.target.value)}
                className="w-24 p-2 border border-slate-300 rounded-md"
                min="0"
              />
              <span className="text-slate-500">ETB</span>
              <span className="text-sm text-slate-500 ml-auto">
                Final Price: <strong>{selectedProduct.basePrice + Number(markup)} ETB</strong>
              </span>
            </div>
          </div>
        )}

        <Button onClick={handleAdd} disabled={!selectedProduct} className="w-full">
          <Plus size={18} className="mr-2" />
          Add to My Store
        </Button>
      </div>
    </Modal>
  );
};

export default CreateProductModal;
